import { Box, Button, Grid, Input, Select, Text, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconBuilding,
  IconPlus,
  IconSearch,
  IconCheck,
  IconBuildingWarehouse,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import { getDataBrandV2 } from "../../../../api/ApiSell";
import { _localization } from "../../../../config/location";
import { API_ROUTE } from "../../../../const/apiRoute";
import { SelectListItemModel } from "../../../../model/SelectListItem copy";
import AddProduct from "./AddProductSelection";
import { useDebouncedValue } from "@mantine/hooks";
import { repositoryWeb } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";

interface SearchCriteria {
  keySearch?: string;
  status?: string;
  paymentMethod?: string;
  invoiceType?: string;
  BrandId?: string;
  ItemCode?: string;
  IsNew?: string;
  StockStatus?: string;
}
type ProductSelected = {
  idItems: number;
  onClose: any;
  fetchDataList: () => void;
};
type FacebookAdProduct = {
  id: number;
  fbAdsId: number;
  productId: number;
  productCode: string;
  productionName: string;
  imageUrl: string | null;
  url: string;
  price: number;
  warranty: string;
  createBy: string | null;
  createTime: string | null;
  creationDate: string;
  createdBy: number;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
};

const ProductSelection = ({
  idItems,
  onClose,
  fetchDataList,
}: ProductSelected) => {
  // Khởi tạo component InventoryReportList
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  type Search = string | number | boolean | object | null;
  const [searchs, setSearchs] = useState<Search>(null);
  const [height, setHeight] = useState(0);
  const [data, setData] = useState<FacebookAdProduct[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  //Lưu selection toàn cục
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [dataBrandOption, setDataBrandOption] = useState<SelectListItemModel[]>(
    [],
  );
  const [brandSearchValue, setBrandSearchValue] = useState("");
  const [debouncedBrandSearch] = useDebouncedValue(brandSearchValue, 500);

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      StockStatus: "true",
    },
  });

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  const styleTableMantine = {
    paddingLeft: "12px",
    paddingRight: "12px",
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "productCode",
        header: "Mã sản phẩm",
      },
      {
        accessorKey: "productionName",
        header: "Tên sản phẩm",
        size: 600,
        minSize: 600,
      },
      {
        accessorKey: "price",
        header: "Giá",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm" fw={500} c="blue">
            {formatCurrencyVND(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "warranty",
        header: "Bảo hành",
      },
      {
        accessorKey: "url",
        header: "Đường dẫn",
        minSize: 600,
      },
    ],
    [],
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.BrandId) {
        queryParams.append("BrandId", search.BrandId);
      }
      if (search && search.ItemCode) {
        queryParams.append("ItemCode", search.ItemCode);
      }
      if (search && search.IsNew) {
        queryParams.append("IsNew", search.IsNew);
      }
      if (search && search.StockStatus && search.StockStatus !== "all") {
        queryParams.append("StockStatus", search.StockStatus);
      }

      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize),
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_PRODUCT_SELECTION
      }?FbAdsId=${idItems}&${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data.lists;
        setData(result);
        setRowCount(response.data.count);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  //   Lấy data thương hiệu sản phẩm
  const fetchDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any, index: number) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        // setDataBrand(response.data.lists);
        setDataBrandOption(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };

  const handleSelectAll = async () => {
    let url = `/FaceBookDynamicAds/get-all-item-id?Skip=${
      pagination.pageIndex * pagination.pageSize
    }&Take=${pagination.pageSize}`;

    const params = new URLSearchParams();
    Object.entries(form.getValues()).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => params.append(key, String(item)));
      } else if (
        typeof value === "string" &&
        value.length > 0 &&
        key === "StockStatus" &&
        value !== "all"
      ) {
        params.append(key, value);
      }
    });

    url += `&${params?.toString()}`;

    const res = await repositoryWeb.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res?.data?.lists?.map((i: any) => i.id) || [];
      const result = data.reduce((acc: any, curr: any) => {
        acc[curr] = true;
        return acc;
      }, {});
      setSelectedProductIds(data);
      setRowSelection(result);
    } else {
      setSelectedProductIds([]);
      setRowSelection({});
    }
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "none",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "invoiceNum"],
        right: ["action1", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.productId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: (updater) => {
      const newSelection =
        typeof updater === "function" ? updater(rowSelection) : updater;
      setRowSelection(newSelection);

      // merge vào selectedProductIds
      const newlySelectedIds = Object.entries(newSelection)
        .filter(([_, isSelected]) => isSelected)
        .map(([rowId]) => Number(rowId));

      setSelectedProductIds((prev) => {
        const merged = new Set([...prev, ...newlySelectedIds]);
        // Xoá id của page hiện tại nếu không còn được tick nữa
        const currentPageIds = data.map((d) => d.productId);
        currentPageIds.forEach((id) => {
          if (!newlySelectedIds.includes(id)) {
            merged.delete(id);
          }
        });
        return Array.from(merged);
      });
    },
    mantineSelectAllCheckboxProps: ({ table }) => ({
      onChange: (event) => {
        const isChecked = event.currentTarget.checked;

        if (isChecked) {
          handleSelectAll();
        } else {
          setSelectedProductIds([]);
          setRowSelection({});
        }
      },
    }),
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, deleteViewStatus, editViewProduct]);

  // Effect để xử lý debounced search cho brand
  useEffect(() => {
    if (debouncedBrandSearch !== undefined) {
      fetchDataBrand(debouncedBrandSearch);
    }
  }, [debouncedBrandSearch]);

  const addItem = async (ids: number[], idFbAds: number) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Thêm sản phẩm!</Title>
            </>
          ),
          size: "550px",
          children: (
            <AddProduct
              idItems={ids}
              idFbAds={idFbAds}
              fetchDataList={fetchDataList}
              onClose={setDeleteViewStatus}
            />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };
  return (
    <Box>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                size="md"
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Input
                size="md"
                placeholder="Nhập mã sản phẩm"
                key={form.key("ItemCode")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("ItemCode")}
              />
              <Select
                size="md"
                placeholder="Xem theo tình trạng"
                leftSection={<IconCheck size={20} color="#15aabf" />}
                data={[
                  { value: "true", label: "Còn mới" },
                  { value: "false", label: "Đã qua sử dụng" },
                ]}
                searchable
                clearable
                key={form.key("IsNew")}
                {...form.getInputProps("IsNew")}
              />

              <Select
                size="md"
                placeholder="Xem theo thương hiệu"
                searchable
                clearable
                data={dataBrandOption || []}
                leftSection={<IconBuilding size={20} color="#15aabf" />}
                searchValue={brandSearchValue}
                onDropdownOpen={() => {
                  if (dataBrandOption.length === 0) {
                    fetchDataBrand();
                  }
                }}
                onSearchChange={(value) => {
                  setBrandSearchValue(value);
                }}
                key={form.key("BrandId")}
                {...form.getInputProps("BrandId")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={700}
              />
              <Select
                size="md"
                placeholder="Tồn kho"
                data={[
                  { label: "Tất cả sản phẩm", value: "all" },
                  { label: "Còn hàng", value: "true" },
                  { label: "Hết hàng", value: "false" },
                ]}
                leftSection={
                  <IconBuildingWarehouse color="#15aabf" size={20} />
                }
                value={form.getValues().StockStatus || null}
                onChange={(e) =>
                  form.setValues((prev) => ({
                    ...prev,
                    StockStatus: e ? e : "all",
                  }))
                }
              />
              <Button
                color="blue"
                variant="outline"
                size="md"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>

          <Button
            mt={10}
            mr={10}
            leftSection={<IconPlus size={20} stroke={1.5} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await addItem(selectedProductIds, idItems);
            }}
            size="md"
          >
            Thêm sản phẩm
          </Button>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ProductSelection;
